import React from 'react';
import './TypingIndicator.css';

interface TypingIndicatorProps {
  username?: string;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ username }) => {
  return (
    <div className="typing-indicator">
      <div className="typing-indicator__dots">
        <span className="typing-indicator__dot" />
        <span className="typing-indicator__dot" />
        <span className="typing-indicator__dot" />
      </div>
      {username && (
        <span className="typing-indicator__text">
          {username} is typing...
        </span>
      )}
    </div>
  );
};

export default TypingIndicator;
